import React from 'react';
import { HelpCircle } from 'lucide-react';

const StatsCard = ({ icon: Icon, title, value, growth, growthLabel }) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className="icon-wrapper">
          <Icon size={20} />
        </div>
        <div className="stat-info">
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <h4>{title}</h4>
            <HelpCircle size={14} color="#6F767E" />
          </div>
          <div className="value">{value}</div>
        </div>
      </div>
      <div className="stat-footer">
        {growthLabel} <span>{growth}</span>
      </div>
    </div>
  );
};

export default StatsCard;
